/**
 * AcceptAllInformative — v1.72.0 (feb-2026).
 *
 * Bottone helper "Accetta le informative facoltative in blocco". Spunta
 * programmaticamente SOLO le dichiarazioni informative/facoltative:
 *   - IVASSComplianceCheckboxes: `signedDeclaration` (art. 1892 c.c.) + `mupSeen` (MUP IVASS)
 *   - ConsensiGranulari facoltativi: `marketing`, `profilazione`, `gruppo_partner`
 *
 * NON spunta (compliance):
 *   - Click-wrap ex art. 1341-1342 c.c. (mai in accetta-tutto)
 *   - Consensi GDPR obbligatori (contratto / contatto_commerciale / trasmissione_compagnie)
 *   - Privacy Policy obbligatoria
 *
 * Il componente è "dumb": espone solo il click handler. Il parent
 * implementa `onAcceptAll` chiamando i setter React opportuni.
 */
import { CheckCheck } from "lucide-react";

/**
 * @param {object} props
 * @param {() => void} props.onAcceptAll
 * @param {boolean}    [props.disabled]
 * @param {string}     [props.className]
 * @param {string}     [props.testid="btn-accept-all-informative"]
 * @param {string}     [props.label] override label
 */
export default function AcceptAllInformative({
  onAcceptAll,
  disabled = false,
  className = "",
  testid = "btn-accept-all-informative",
  label = "Accetta le informative facoltative in blocco",
}) {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <button
        type="button"
        onClick={onAcceptAll}
        disabled={disabled}
        data-testid={testid}
        className="inline-flex items-center gap-2 self-start px-3.5 py-2 rounded-full border border-[#163321]/30 bg-white hover:bg-[#163321]/5 text-[#163321] text-xs font-medium transition-all disabled:opacity-40 disabled:cursor-not-allowed"
      >
        <CheckCheck className="w-3.5 h-3.5" />
        {label}
      </button>
      <p className="text-[10.5px] text-[#4A5E51]/80 leading-snug">
        Spunta i consensi non vincolanti: MUP IVASS, dichiarazione di veridicità,
        marketing, profilazione, comunicazioni al gruppo partner. I consensi
        obbligatori (privacy, elaborazione preventivo, trasmissione compagnie)
        restano da confermare manualmente.
      </p>
    </div>
  );
}
